import * as angular from 'angular';
import ChatMessage from "../../models/chat/chatMessage";
import {Plant} from "../../models/navigation";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import ShopServiceName, {ShopService} from "../../services/shops/shops.service";
import NavigationServiceName, {NavigationService} from "../../services/navigation/navigation.service";
import ChatServiceName, {ChatHub, ChatService} from "../../services/chat/chat.service";
import UserProfileName, {UserProfile} from "../../models/userProfile";
import DateUtilityService from "../../services/utility/dateutility.service";
import * as _ from "lodash";

let requires = [ShopServiceName, NavigationServiceName, ChatServiceName, UserProfileName];

export interface ViewChatController {
  chatItems: ChatMessage[];
  plant: Plant;
  shop: apsViewModels.ShopNavigation;
  count: number;
  desc: boolean;
  displayDate(date: Date): string;
  getLocation(chatItem: ChatMessage): string;
}

class ViewChatCtrl implements ViewChatController {
  count: number;
  desc: boolean;
  plant: Plant;
  shop: apsViewModels.ShopNavigation;
  chatItems: ChatMessage[];
  private $modal: mm.foundation.modal;
  private plantId: string;
  private shopId: string;
  private shopConfig: apsViewModels.ShopConfigurationWithShifts;
  private hub: ChatHub;
  private userProfile: UserProfile;

  constructor(chatService: ChatService,
              navigationService: NavigationService,
              $scope: angular.IScope,
              $timeout: angular.ITimeoutService,
              $modal: mm.foundation.modal,
              shopService: ShopService,
              userProfile: UserProfile,
              $stateParams: any) {
    this.$modal = $modal;
    this.userProfile = userProfile;
    this.plantId = $stateParams.plantId;
    this.shopId = $stateParams.shopId;

    $timeout(() => {
      navigationService.getNavigation()
        .then(navigation => {
          this.plant = _.find(navigation.plants(), {id: this.plantId});
          if (this.plant) {
            this.shop = _.find(this.plant.shops, {id: this.shopId});
          }
        });

      shopService.getShopConfiguration(this.shopId)
        .then(shop => this.shopConfig = shop);

      userProfile.read().then(userData => {
        chatService.getMessages(this.plantId, this.shopId)
          .then(data => {
            this.chatItems = data;
            this.filterAndSortMessages();

            this.hub = chatService.createHub(this.shopId, (chatAdded: apsViewModels.ChatAdded) => {
              $timeout(() => {
                let message = new ChatMessage(chatAdded, userData);
                if (this.desc) {
                  this.chatItems.push(message);
                  if (this.count && this.chatItems.length > this.count) {
                    this.chatItems.splice(0, 1);
                  }
                } else {
                  this.chatItems.unshift(message);
                  if (this.count && this.chatItems.length > this.count) {
                    this.chatItems.pop();
                  }
                }
              });
            });
          });
      });
    });

    $scope.$on('$destroy', () => {
      if (this.hub) {
        this.hub.uninitialize();
      }
    });
  }

  private filterAndSortMessages(): void {
    if (!this.chatItems || this.chatItems.length === 0) {
      return;
    }

    this.chatItems.forEach(element => { if (element.defectLegacyId === null)       
      return element.defectLegacyId = parseInt('');
    });

    if (!this.desc && (!this.count || this.count >= this.chatItems.length)) {
      return;
    }

    let items = _(this.chatItems);
    if (this.count && this.count < this.chatItems.length) {
      items = items.take(this.count);
    }
    if (this.desc) {
      items = items.reverse();
    }
    this.chatItems = items.value();
  }

  displayDate(date: Date): string {
    return DateUtilityService.formatTimeOnly(date, this.plant ? this.plant.timeZoneId : null);
  }

  getLocation(chatItem: ChatMessage): string {
    return chatItem.location(this.shopConfig);
  }
}

export default angular.module('aps.controller.viewChat', requires)
  .controller('ViewChatCtrl', ViewChatCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/chat/viewChat.controller.ts